import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useEmailDisclosure({
	impersonationContext,
	templateId,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	templateId?: string;
	enabled?: boolean;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled: enabled && !!templateId,
		refetchOnWindowFocus: false,
		staleTime: 30_000,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<string>({
				path: Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'email/resolvedDisclosure',
					queryParams: templateId ? { templateId } : undefined,
				}),
				method: 'GET',
				throwOn404: false,
			}),
		retry: 0,
		queryKey: ['emailDisclosure', { templateId, impersonationContextId: impersonationContext?.account?.id }],
	});
}
